import React, { useEffect, useRef, useState } from "react";
import cx from "classnames";
import styled from 'styled-components';
import { AiOutlinePlusCircle, AiOutlineMinusCircle } from 'react-icons/ai';
import { ICardProps } from ".";
import { useCardDeckContext } from "../../context/CardDeckContext";
import { getReplacedContent, parseHTML } from "../../utilities/markdown";

const SimpleTextCardContainer = styled.div`
&.card {
    border-color: black !important;
    border-radius: 0;
}

// Class for the accordion to overwrite margin from any class added in props
&.no-margin {
    margin: 0 !important;
}

.plus {
    height: 1.33rem;
    width: 1.33rem;
    min-height: 1.33rem;
    min-width: 1.33rem;
    svg {
        height: 100%;
        width: 100%;
    }
}
.custom-card-title {
    font-size: 1.33rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1.47rem;
}
.card-body {
    font-size: 0.89rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1.33rem;
}
.accordion-content, .card-footer {
    transition: all .2s ease-in-out;
    overflow: hidden;
}
.card-footer > div:empty {
    padding: 0 !important;
}
`;

const SimpleTextCard = (props: ICardProps) => {
    const { className, editorClassObj, cmsId, cardTitle, cardBody, cardFooter, cardIndex } = props;
    const { selectedCard, setSelectedCard, enableAccordion } = useCardDeckContext();
    const accordionContentRef = useRef(null);
    const accordionFooterRef = useRef(null);
    const [isMobileWidth, setIsMobileWidth] = useState(false);

    useEffect(() => {
        setIsMobileWidth(window.innerWidth < 576);
    }, []);

    function renderAccordionIcon() {
        return (
            <div className="plus d-flex d-sm-none">
                {cardIndex === selectedCard ? <AiOutlineMinusCircle /> : <AiOutlinePlusCircle />}
            </div>
        );
    };

    function getAccordionStyles(ref) {
        return enableAccordion && isMobileWidth ? {
            maxHeight: cardIndex === selectedCard ? ref.current.scrollHeight : 0,
            opacity: cardIndex === selectedCard ? 1 : 0
        } : null;
    }

    return (
        <SimpleTextCardContainer data-id={cmsId} className={cx(className, editorClassObj, 'card border-0 py-3', {'border-bottom no-margin': enableAccordion && isMobileWidth })}>
            <div className="card-body m-0 p-0">
                <div className={cx('d-flex align-items-center justify-content-between')} onClick={() => setSelectedCard(cardIndex === selectedCard ? null : cardIndex)}>
                    <h3 className={cx("custom-card-title m-0", {'mb-2': !enableAccordion && !isMobileWidth })}>
                        {typeof cardTitle === 'string' ? parseHTML(cardTitle, 'SimpleText') : getReplacedContent(cardTitle)}
                    </h3>
                    {enableAccordion ? renderAccordionIcon() : null}
                </div>
                <div ref={accordionContentRef} className="accordion-content" style={getAccordionStyles(accordionContentRef)}>
                    <div className={cx("mt-0", {'mt-3 mt-sm-0': enableAccordion})}>
                        {typeof cardBody === 'string' ? parseHTML(cardBody, 'SimpleText') : getReplacedContent(cardBody)}
                    </div>
                </div>
            </div>
            <div ref={accordionFooterRef} className="card-footer border-0 m-0 p-0" style={getAccordionStyles(accordionFooterRef)}>
                <div className="p-1 pt-4">{typeof cardFooter === 'string' ? parseHTML(cardFooter, 'SimpleText') : getReplacedContent(cardFooter)}</div>
            </div>
        </SimpleTextCardContainer>
    );
};

export default SimpleTextCard;